import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAnalytics from "vue-analytics";
import "./registerServiceWorker";

/* css */
import "./assets/libraries/ui-kit/now-ui-kit.min.css";
import "./assets/libraries/bootstrap/css/bootstrap.min.css";
import "./assets/libraries/ionicons/css/ionicons.min.css";
import "./assets/libraries/contentbuilder/content.css";
import "./assets/libraries/ui-kit/demo.css";
import "./assets/css/iv2-customize.css";
import "./assets/css/iv2-page-animation.css";
import "./assets/css/iv2-theme-b-component.css";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

Vue.use(VueAnalytics, {
    id: axios.get("/json/settings.json").then((response) => {
        return response.data.settings.general.ga_tracking_id;
    }),
});

new Vue({
    router,
    render: (h) => h(App),

    data() {
        return {
            settings: [],
        };
    },

    created() {
        axios.get("/json/settings.json").then((response) => {
            this.settings = response.data.settings;

            document
                .querySelector("meta[name='keywords']")
                .setAttribute("content", this.settings.general.site_keywords);
            document
                .querySelector("meta[name='description']")
                .setAttribute(
                    "content",
                    this.settings.general.site_description
                );
            document
                .querySelector("meta[property='og:description']")
                .setAttribute(
                    "content",
                    this.settings.general.site_description
                );
            document
                .querySelector("meta[property='og:url']")
                .setAttribute("content", location.href.slice(0, -1));
            document
                .querySelector("meta[property='og:site_name']")
                .setAttribute("content", this.settings.general.profile.name);
            // document
            //     .querySelector("meta[property='og:image']")
            //     .setAttribute("content", this.settings.general.site_title);

            // document
            //     .querySelector("meta[name='twitter:site']")
            //     .setAttribute("content", "@" + this.settings.sns.twitter_id);
        });
    },
}).$mount("#app");
